import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// Icon base URL from Supabase
const ICON_BASE_URL = 'https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/icons2'

function Home() {
  const { t, i18n } = useTranslation()
  const [hoveredProcess, setHoveredProcess] = useState<number | null>(null)

  const processSteps = [
    {
      id: 1,
      title: t('home.process.step1.title'),
      description: t('home.process.step1.description'),
      icon: `${ICON_BASE_URL}/chat-bubble-front-color.png`,
      color: 'baby-blue'
    },
    {
      id: 2,
      title: t('home.process.step2.title'),
      description: t('home.process.step2.description'),
      icon: `${ICON_BASE_URL}/computer-front-color.png`,
      color: 'pink'
    },
    {
      id: 3,
      title: t('home.process.step3.title'),
      description: t('home.process.step3.description'),
      icon: `${ICON_BASE_URL}/rocket-front-color.png`,
      color: 'baby-blue'
    }
  ]

  const portfolioProjects = [
    {
      id: 1,
      name: 'Masala Chai Tea',
      industry: 'Tea Shop',
      industryEs: 'Tienda de Té',
      screenshot: 'https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/da/Screenshot%202026-01-05%20222357.png',
      url: 'https://masalachaitea.net/'
    },
    {
      id: 2,
      name: 'Magic Hands',
      industry: 'Cleaning Services',
      industryEs: 'Servicios de Limpieza',
      screenshot: 'https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/da/Screenshot%202026-01-05%20222313.png',
      url: 'https://magichandstx.com/'
    },
    {
      id: 3,
      name: 'Lopez Brothers',
      industry: 'Land Clearing & Excavation',
      industryEs: 'Desmonte y Excavación',
      screenshot: 'https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/da/Screenshot%202026-01-05%20222332%20(1).png',
      url: 'https://lopezbrostx.com/'
    }
  ]

  const testimonials = [
    {
      id: 1,
      name: t('home.testimonials.client1.name'),
      business: t('home.testimonials.client1.business'),
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client1.quote'),
      rating: 5
    },
    {
      id: 2,
      name: t('home.testimonials.client2.name'),
      business: t('home.testimonials.client2.business'),
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client2.quote'),
      rating: 5
    },
    {
      id: 3,
      name: t('home.testimonials.client3.name'),
      business: t('home.testimonials.client3.business'),
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client3.quote'),
      rating: 5
    },
    {
      id: 4,
      name: t('home.testimonials.client4.name'),
      business: t('home.testimonials.client4.business'),
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client4.quote'),
      rating: 5
    },
    {
      id: 5,
      name: t('home.testimonials.client5.name'),
      business: t('home.testimonials.client5.business'),
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client5.quote'),
      rating: 5
    },
    {
      id: 6,
      name: t('home.testimonials.client6.name'),
      business: t('home.testimonials.client6.business'),
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client6.quote'),
      rating: 5
    },
    {
      id: 7,
      name: t('home.testimonials.client7.name'),
      business: t('home.testimonials.client7.business'),
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client7.quote'),
      rating: 5
    },
    {
      id: 8,
      name: t('home.testimonials.client8.name'),
      business: t('home.testimonials.client8.business'),
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client8.quote'),
      rating: 5
    },
    {
      id: 9,
      name: t('home.testimonials.client9.name'),
      business: t('home.testimonials.client9.business'),
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client9.quote'),
      rating: 5
    },
    {
      id: 10,
      name: t('home.testimonials.client10.name'),
      business: t('home.testimonials.client10.business'),
      image: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?auto=format&fit=crop&q=80&w=150',
      quote: t('home.testimonials.client10.quote'),
      rating: 5
    }
  ]

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-baby-blue-200 via-baby-blue-50 to-pink-200 px-4 py-12 md:py-16 lg:py-24 overflow-hidden">
        {/* Grid Pattern Background */}
        <div
          className="absolute inset-0 bg-grid-light"
          aria-hidden="true"
        />

        <div className="relative max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Hero Content */}
            <div className="text-center lg:text-left">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
                {t('home.hero.title1')}{' '}
                <span className="text-baby-blue-600">{t('home.hero.ready')}</span> {t('home.hero.in')}{' '}
                <span className="text-pink-500">{t('home.hero.hours')}</span>
              </h1>

              <p className="text-base md:text-lg lg:text-xl text-gray-700 mb-8 max-w-2xl mx-auto lg:mx-0">
                {t('home.hero.subtitle')}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="/contact"
                  className="w-full sm:w-auto h-12 px-8 bg-baby-blue-600 text-white font-semibold rounded-lg hover:bg-baby-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center"
                >
                  {t('home.hero.cta1')}
                </a>
                <a
                  href="/services"
                  className="w-full sm:w-auto h-12 px-8 bg-white text-baby-blue-600 font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 border-2 border-baby-blue-600 flex items-center justify-center"
                >
                  {t('home.hero.cta2')}
                </a>
              </div>

              {/* Trust Indicators */}
              <div className="mt-8 md:mt-12 flex flex-row flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-8 text-xs md:text-base text-gray-600">
                <div className="flex items-center gap-1 md:gap-2">
                  <img
                    src={`${ICON_BASE_URL}/clock-front-color.png`}
                    alt="Fast delivery"
                    className="w-4 h-4 md:w-6 md:h-6"
                  />
                  <span>{t('home.hero.trust1')}</span>
                </div>
                <div className="flex items-center gap-1 md:gap-2">
                  <img
                    src={`${ICON_BASE_URL}/sheild-front-color.png`}
                    alt="Secure"
                    className="w-4 h-4 md:w-6 md:h-6"
                  />
                  <span>{t('home.hero.trust2')}</span>
                </div>
                <div className="flex items-center gap-1 md:gap-2">
                  <img
                    src={`${ICON_BASE_URL}/dollar-front-color.png`}
                    alt="Affordable"
                    className="w-4 h-4 md:w-6 md:h-6"
                  />
                  <span>{t('home.hero.trust3')}</span>
                </div>
              </div>
            </div>

            {/* Hero Image */}
            <div className="relative mt-8 lg:mt-0">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-300">
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800"
                  alt="Modern website design on laptop"
                  crossOrigin="anonymous"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-baby-blue-600/20 to-pink-500/20" />
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-white rounded-xl shadow-xl p-4 md:p-6 border-2 border-pink-500">
                <div className="flex items-center gap-3">
                  <img
                    src={`${ICON_BASE_URL}/star-front-color.png`}
                    alt="Rating"
                    className="w-8 h-8 md:w-12 md:h-12"
                  />
                  <div>
                    <div className="text-2xl md:text-3xl font-bold text-gray-900">5.0</div>
                    <div className="text-xs md:text-sm text-gray-600">Client Rating</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="bg-white px-4 py-12 md:py-16 lg:py-24">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              {t('home.process.title')}
            </h2>
            <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
              {t('home.process.subtitle')}
            </p>
          </div>

          {/* Process Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {processSteps.map((step, index) => (
              <div
                key={step.id}
                className="relative group"
                onMouseEnter={() => setHoveredProcess(step.id)}
                onMouseLeave={() => setHoveredProcess(null)}
              >
                {/* Connector Line - Desktop Only */}
                {index < processSteps.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-1/2 w-full h-1 bg-gradient-to-r from-baby-blue-300 to-pink-300 z-0" />
                )}

                {/* Step Card */}
                <div className={`relative bg-white rounded-2xl p-6 md:p-8 border-2 transition-all duration-300 ${
                  hoveredProcess === step.id
                    ? 'border-baby-blue-500 shadow-xl transform -translate-y-2'
                    : 'border-gray-200 shadow-md'
                }`}>
                  {/* Step Number */}
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-baby-blue-500 to-pink-500 text-white text-xl font-bold rounded-full flex items-center justify-center shadow-lg">
                    {step.id}
                  </div>

                  {/* Icon */}
                  <div className="flex justify-center mb-6">
                    <div className={`w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-${step.color}-100 flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300`}>
                      <img
                        src={step.icon}
                        alt={step.title}
                        className="w-12 h-12 md:w-16 md:h-16"
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 text-center">
                    {step.title}
                  </h3>
                  <p className="text-base text-gray-600 text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Below Process */}
          <div className="text-center mt-12 md:mt-16">
            <a
              href="/contact"
              className="inline-flex items-center gap-2 h-12 md:h-14 px-8 md:px-10 bg-gradient-to-r from-baby-blue-600 to-baby-blue-700 text-white font-semibold rounded-lg hover:from-baby-blue-700 hover:to-baby-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              <span className="text-base md:text-lg">{t('home.process.cta')}</span>
              <img
                src={`${ICON_BASE_URL}/pencil-front-color.png`}
                alt="Arrow"
                className="w-5 h-5"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="relative bg-white px-4 py-12 md:py-16 lg:py-24 overflow-hidden">
        {/* Subtle grid pattern background */}
        <div
          className="absolute inset-0 -z-10 bg-grid-light opacity-50"
          aria-hidden="true"
        />

        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              {t('home.portfolio.title')}
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              {t('home.portfolio.subtitle')}
            </p>
          </div>

          {/* Portfolio Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {portfolioProjects.map((project) => (
              <a
                key={project.id}
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group block"
              >
                <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-baby-blue-200 transform hover:-translate-y-2">
                  {/* Browser Mockup Frame */}
                  <div className="bg-gray-100 px-4 py-3 flex items-center gap-2 border-b border-gray-200">
                    <div className="flex gap-1.5">
                      <div className="w-3 h-3 rounded-full bg-red-400"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                      <div className="w-3 h-3 rounded-full bg-green-400"></div>
                    </div>
                    <div className="flex-1 mx-4">
                      <div className="bg-white rounded-md px-3 py-1 text-xs text-gray-400 truncate">
                        {project.url.replace('https://', '')}
                      </div>
                    </div>
                  </div>

                  {/* Screenshot */}
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={project.screenshot}
                      alt={`${project.name} website`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      crossOrigin="anonymous"
                    />
                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-baby-blue-600/90 via-baby-blue-600/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                      <span className="inline-flex items-center gap-2 bg-white text-baby-blue-600 font-semibold px-6 py-2 rounded-lg shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                        {t('home.portfolio.visitSite')}
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </span>
                    </div>
                  </div>

                  {/* Project Info */}
                  <div className="p-5">
                    <div className="flex items-start justify-between gap-2">
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-1 group-hover:text-baby-blue-600 transition-colors">
                          {project.name}
                        </h3>
                        <p className="text-sm text-gray-500 flex items-center gap-2">
                          <span className="inline-block w-2 h-2 rounded-full bg-pink-400"></span>
                          {i18n.language === 'es' ? project.industryEs : project.industry}
                        </p>
                      </div>
                      {/* Mobile tap indicator - hidden on desktop where hover works */}
                      <span className="md:hidden flex items-center gap-1 text-xs text-baby-blue-600 font-medium bg-baby-blue-50 px-2 py-1 rounded-full">
                        {t('home.portfolio.visitSite')}
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-10 md:mt-12">
            <p className="text-gray-600 mb-4">{t('home.portfolio.ctaText')}</p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-baby-blue-600 hover:bg-baby-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              {t('home.hero.cta1')}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="bg-gradient-to-br from-baby-blue-50 to-pink-50 py-12 md:py-16 lg:py-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              {t('home.testimonials.title')}
            </h2>
            <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
              {t('home.testimonials.subtitle')}
            </p>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          {/* Gradient Overlays for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-8 md:w-24 bg-gradient-to-r from-baby-blue-50 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-8 md:w-24 bg-gradient-to-l from-pink-50 to-transparent z-10 pointer-events-none" />

          {/* Scrolling Container */}
          <div
            className="flex gap-6 py-4"
            style={{
              animation: 'scroll 40s linear infinite',
              width: 'max-content'
            }}
          >
            {/* First set of testimonials */}
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="flex-shrink-0 w-[320px] md:w-[380px] bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
              >
                {/* Rating Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <img
                      key={i}
                      src={`${ICON_BASE_URL}/star-front-color.png`}
                      alt="Star"
                      className="w-5 h-5"
                    />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed italic line-clamp-4">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    crossOrigin="anonymous"
                    className="w-12 h-12 rounded-full object-cover border-2 border-baby-blue-300"
                  />
                  <div>
                    <div className="font-bold text-gray-900 text-base">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-600">
                      {testimonial.business}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {testimonials.map((testimonial) => (
              <div
                key={`dup-${testimonial.id}`}
                className="flex-shrink-0 w-[320px] md:w-[380px] bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
              >
                {/* Rating Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <img
                      key={i}
                      src={`${ICON_BASE_URL}/star-front-color.png`}
                      alt="Star"
                      className="w-5 h-5"
                    />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed italic line-clamp-4">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    crossOrigin="anonymous"
                    className="w-12 h-12 rounded-full object-cover border-2 border-baby-blue-300"
                  />
                  <div>
                    <div className="font-bold text-gray-900 text-base">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-600">
                      {testimonial.business}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4">

          {/* Social Proof Banner */}
          <div className="mt-12 md:mt-16 bg-white rounded-2xl shadow-xl p-4 md:p-8 border-2 border-pink-200">
            <div className="grid grid-cols-3 gap-2 md:gap-8 text-center">
              <div className="flex flex-col items-center gap-1 md:gap-2">
                <img
                  src={`${ICON_BASE_URL}/megaphone-front-color.png`}
                  alt="Clients"
                  className="w-8 h-8 md:w-16 md:h-16"
                />
                <div className="text-xl md:text-4xl font-bold text-baby-blue-600">500+</div>
                <div className="text-xs md:text-base text-gray-600">{t('home.stats.clients')}</div>
              </div>
              <div className="flex flex-col items-center gap-1 md:gap-2">
                <img
                  src={`${ICON_BASE_URL}/computer-front-color.png`}
                  alt="Websites"
                  className="w-8 h-8 md:w-16 md:h-16"
                />
                <div className="text-xl md:text-4xl font-bold text-pink-500">1000+</div>
                <div className="text-xs md:text-base text-gray-600">{t('home.stats.websites')}</div>
              </div>
              <div className="flex flex-col items-center gap-1 md:gap-2">
                <img
                  src={`${ICON_BASE_URL}/star-front-color.png`}
                  alt="Rating"
                  className="w-8 h-8 md:w-16 md:h-16"
                />
                <div className="text-xl md:text-4xl font-bold text-baby-blue-600">5.0</div>
                <div className="text-xs md:text-base text-gray-600">{t('home.stats.rating')}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="relative bg-gradient-to-r from-baby-blue-600 to-baby-blue-700 px-4 py-12 md:py-16 lg:py-20 overflow-hidden">
        {/* Grid Pattern - subtle on colored background */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.08) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.08) 1px, transparent 1px)
            `,
            backgroundSize: '32px 32px',
          }}
          aria-hidden="true"
        />

        <div className="relative max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            {t('home.cta.title')}
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-baby-blue-100 mb-8">
            {t('home.cta.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="w-full sm:w-auto h-12 md:h-14 px-8 md:px-10 bg-white text-baby-blue-600 font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center text-base md:text-lg"
            >
              {t('home.cta.button1')}
            </a>
            <a
              href="/services"
              className="w-full sm:w-auto h-12 md:h-14 px-8 md:px-10 bg-transparent text-white font-semibold rounded-lg hover:bg-baby-blue-800 transition-all duration-200 border-2 border-white flex items-center justify-center text-base md:text-lg"
            >
              {t('home.cta.button2')}
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
